/** @format */

export const DEFAULT_TEST_ID = 'model-journey-fan';

export const FAN_MODEL_COUNT = 5;

/**
 * The longest tagline a card will show before cutting it short.
 *
 * The upstream is supposed to keep these inside the same limit, so this should
 * never fire. It is here because a card in a hand is the one place with no room to
 * absorb a longer one: every card in a hand is the same size, so one overlong
 * tagline would set the height of all five. The detail card, which has room, shows
 * its copy in full.
 */
export const CARD_TAGLINE_LIMIT = 64;

/**
 * Which side of the "you are here" marker a hand sits on.
 *
 * The values are what the analytics events report as the side a card was drawn
 * from, so they are read by whoever reads the reports and not only by the
 * stylesheet.
 */
export enum TimelineSide {
    BEFORE = 'before',
    AFTER = 'after',
}

/**
 * The datalayer event a drawn card is reported as, carrying which model was drawn
 * and which hand it came from — `before` for the models customers owned first,
 * `after` for the ones they bought next.
 *
 * Named for the section a reader sees this card in — `KIT_JOURNEY_*` — rather
 * than for the experiment as a whole, the same scheme every event in
 * `beta-model-insights` follows: a section-specific event is named for its
 * section, so the reports can tell one section's numbers from another's.
 *
 * Declared here rather than added to `client/global/analytics`, the same as the
 * feedback event, so that nothing outside `beta-model-insights` has to know this
 * experiment exists.
 */
export const JOURNEY_CARD_EVENT = 'KIT_JOURNEY_CARD_CLICK';

/**
 * The datalayer event the hero's action is reported as, for the reader who went
 * looking for this section from the top of the page rather than scrolling into it.
 *
 * Named `KIT_INSIGHTS_*` rather than `KIT_JOURNEY_*`, because this action opens
 * both insights sections below it, not just this one — the model page's
 * product-page counterpart (`INSIGHTS_ACTION_EVENT`) shares the same prefix and
 * is told apart from this one only by which page's action fired it.
 *
 * Reported by the hero, which is outside this folder — hence this name being
 * re-exported from `features/model` — but it is this section's event: it says the
 * section was asked for, and it goes when the section does.
 */
export const JOURNEY_ACTION_EVENT = 'KIT_INSIGHTS_MODEL_PAGE_ACTION_CLICK';
